import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

export const RecirectV2ToV1 = () => {
  const params = useParams()
  const remainingPath = params['*'] || ''

  return <Navigate to={`/admin/dashboard/store-design/${remainingPath}`} replace />
}
